var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntersect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 107,
    viewBox: "0 0 65 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4148_6360",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 0C13.1959 9.97602 0 30.1218 0 53.3497C0 76.5776 13.1959 96.7234 32.5 106.699C51.8041 96.7234 65 76.5776 65 53.3497C65 30.1218 51.8041 9.97602 32.5 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 0C13.1959 9.97602 0 30.1218 0 53.3497C0 76.5776 13.1959 96.7234 32.5 106.699C51.8041 96.7234 65 76.5776 65 53.3497C65 30.1218 51.8041 9.97602 32.5 0Z",
    fill: "#FFFAE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0L33.4184 -1.7772L32.5 -2.25182L31.5816 -1.77719L32.5 0ZM32.5 106.699L31.5816 108.477L32.5 108.951L33.4184 108.477L32.5 106.699ZM31.5816 -1.77719C11.639 8.52878 -2.00048 29.3447 -2.00048 53.3497H2.00048C2.00048 30.8989 14.7528 11.4233 33.4184 1.77719L31.5816 -1.77719ZM-2.00048 53.3497C-2.00048 77.3547 11.639 98.1706 31.5816 108.477L33.4184 104.922C14.7528 95.2762 2.00048 75.8005 2.00048 53.3497H-2.00048ZM33.4184 108.477C53.361 98.1706 67.0005 77.3547 67.0005 53.3497H62.9995C62.9995 75.8005 50.2472 95.2762 31.5816 104.922L33.4184 108.477ZM67.0005 53.3497C67.0005 29.3447 53.361 8.52877 33.4184 -1.7772L31.5816 1.7772C50.2472 11.4233 62.9995 30.8989 62.9995 53.3497H67.0005Z",
    fill: "#FFFAE6",
    mask: "url(#path-1-inside-1_4148_6360)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersect);
export default __webpack_public_path__ + "static/media/intersect.151b964a7085052034b722f27f6efbd9.svg";
export { ForwardRef as ReactComponent };